import { css } from "@emotion/react"
import { graphql, Link } from "gatsby"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import Fade from "react-reveal/Fade"
import LandingLatestStory from "../components/blog/landingLatestStory"
import "../components/common/Benefit-box/Benefit.scss"
import Buttons from "../components/common/button"
import CarouselComponent from "../components/common/carousel-component"
import CTA from "../components/common/CTA"
import Frame from "../components/common/frame"
import IntegrationWheel from "../components/common/IntegrationWheel/IntegrationWheel"
import "../components/common/Latest-Resources-Section/LatestResourcesV2.scss"
import SVGIcon from "../components/common/SVGIcon"
import WistiaVideoOnclickEmbed from "../components/common/wistia-video-onclick-embed.js"
import DoubleNavbar from "../components/DoubleNavbar.js"
import "../styles/pages/home-2025.scss"

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2.19,
  },
  tablet: {
    breakpoint: { max: 1024, min: 767 },
    items: 1.2,
  },
  mobile: {
    breakpoint: { max: 767, min: 500 },
    items: 1.2,
  },
  mobile1: {
    breakpoint: { max: 500, min: 0 },
    items: 1.2,
  },
}
const darkColors = ["#FE7D7D", "#D67FBF", "#8E97E1", "#B0E9A4"]
const lightColors = ["#FFC3C3", "#FFD1F3", "#D4D9FF", "#e0ffd9"]

const Home2025 = ({ data }) => {
  const {
    heroSection,
    newField,
    ctaBoxes,
    navigationBlock,
    seo,
    pageImages,
  } = data?.SuperOps?.pages[0]
  const latestEpisode = data?.SuperOps?.episodes[0]
  const latestEbook = data?.SuperOps?.resources[0]
  const introImage = newField[0]?.image[0]?.url
  const introVideo = newField[0]?.image[1]?.url
  const bodyContent = newField[1]
  const testimonial = newField[2]
  const watchFullProtectors = newField[3]
  const availabilities = newField[4]
  const resources = newField[5]
  const promotions = newField[7]
  const verticalTab = navigationBlock[0]
  const scatterPlot = newField[8]
  const videobox = newField[9]
  const channelBox = newField[10]

  const [isMobile, setIsMobile] = useState(false)
  const [playVideo, setPlayVideo] = useState(false)
  const [height, setHeight] = useState(0)
  const videoRef = useRef()
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (videoRef.current) {
        setHeight(videoRef.current.clientHeight)
      }
    })
    if (videoRef.current) {
      observer.observe(videoRef.current)
    }
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkIsMobile()
    window.addEventListener("resize", checkIsMobile)
    return () => window.removeEventListener("resize", checkIsMobile)
  }, [])

  return (
    <div className="home-2025">
      <Frame className="outer-container" seo={seo} bigFooter>
        <DoubleNavbar navType="double-nav" />

        <section className="hero-container position-relative overflow-hidden">
          <div className="Layout-container-big">
            <div className="hero-section d-flex align-items-center text-center flex-column overflow-hidden position-relative">
              <video
                autoPlay
                loop
                muted
                disablePictureInPicture
                preload="auto"
                src={pageImages?.[9]?.url}
                className="red-stripe-current d-dsk position-absolute reveal-1"
              />
              <div className="title-wrapper down-to-up-1 w-100">
                {parse(heroSection?.heading?.html)}
              </div>
              <p className="sub-title down-to-up-2 font-poppins">
                {heroSection?.content?.text}
              </p>
              <div className="buttons-wrapper position-relative">
                <div className="hero-buttons prelative d-flex gap-16 flex-wrap down-to-up-3">
                  <Buttons
                    theme="primary-new down-to-up-4"
                    link={heroSection?.primaryButtonLink}
                    text={heroSection?.primaryButtonText}
                  />
                  <Buttons
                    theme="primary-new white-new  down-to-up-4"
                    link={heroSection?.secondaryButtonLink}
                    text={heroSection?.secondaryButtonText}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="intro-img-wrapper Layout-container-big w-100 mx-auto position-relative down-to-up-3">
          <video
            autoPlay
            loop
            disablePictureInPicture
            muted
            preload="auto"
            src={introVideo}
            className="home-into-video w-100 br10 home-intro-image d-dsk"
          />
          <img
            className="w-100 d-mob"
            src={introImage}
            alt="home-intro-image"
          />
        </section>

        <section
          className="rive-container d-flex flex-column align-items-center mx-auto text-center"
          id="arc_rive_id"
        >
          <Fade bottom duration={1000}>
            {parse(bodyContent?.blockContent?.html)}

            <Fade bottom distance="30px" duration={1300}>
              <IntegrationWheel dataOne={pageImages[10].url} />
            </Fade>

            <Fade bottom duration={1700}>
              <div className="rive-mb-wrapper">
                <img
                  className="rive-img-mob d-mob"
                  src={pageImages[8]?.url}
                  alt=""
                />
              </div>
            </Fade>
          </Fade>
        </section>

        <section className="video-cta-section">
          <div className="Layout-container-vdcta">
            <div className="video-cta-wrapper col-lg-11">
              <Row className="cta-wrapper">
                <Col lg={6} className="content">
                  <div className="content-wrapper">
                    <div className="heading">
                      {parse(videobox?.cardContent[0]?.html)}
                    </div>
                    <p className="sub-heading">{videobox?.cardText[0]}</p>
                  </div>
                </Col>
                <Col lg={5} className="video-wrapper">
                  <div className="mt-70px">
                    <div className="video-div">
                      <div
                        className={`video-player position-relative ${
                          playVideo ? "fade-out-effect" : "fade-in-effect"
                        }`}
                        onClick={() => setPlayVideo(true)}
                        role="button"
                        tabIndex={0}
                      >
                        <div ref={videoRef} className="position-absolute z-1">
                          <WistiaVideoOnclickEmbed
                            videoScreenshot={videobox?.image?.[0]?.url}
                          />
                        </div>
                      </div>
                      <iframe
                        className="prelative w-100"
                        style={{ height: `${height}px` }}
                        src={`${videobox.cardTitle[0]}&rel=0&autoplay=${
                          playVideo ? 1 : 0
                        }&muted=1`}
                        frameborder="0"
                        allowfullscreen="allowfullscreen"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </section>

        <PromotionCards
          tittleTags={promotions?.cardHeading}
          subTittleTags={promotions?.cardTitle}
          descriptions={promotions?.cardLinks}
          creditTags={promotions?.cardText}
          subCreditTags={promotions?.cardSubText}
          bgColors={promotions?.multiOption[0].option}
          headingHtml={promotions?.cardContent[0].html}
        />

        <NestedVerticalTabs data={verticalTab} />

        <section className="cta-black-red-stripes mx-auto">
          <CTA
            data={[ctaBoxes[0]]}
            containerClass
            lgLeft={6}
            lgRight={4}
            newButton
            isSecondaryBtn
            newDesign
          />
        </section>

        <SliderTestimonial
          testimonial={testimonial}
          bgImg={pageImages?.[6]?.url}
        />

        <Fade bottom duration={1000}>
          <section className="channel-section">
            <div className="Layout-container-big channel-cntr ">
              <Row className="channel-wrapper mx-auto align-items-center justify-content-center">
                <Col lg={6} className="typography-wrapper">
                  <div className="typo">
                    <div className="heading-wrapper">
                      <Fade bottom duration={1000}>
                        {parse(channelBox?.cardContent[0]?.html)}
                      </Fade>
                    </div>
                  </div>
                </Col>
                <Col lg={6} className="badge-wrapper">
                  <div></div>
                  <div className="image-wrapper">
                    <Fade bottom duration={1000}>
                      <img
                        src={
                          isMobile
                            ? channelBox?.image[1]?.url
                            : channelBox?.image[0]?.url
                        }
                        alt="badge"
                        className="w-100"
                      />
                    </Fade>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </Fade>

        <Fade bottom duration={1000}>
          <section className="data-protectors">
            <Row className="dp-wrapper mx-auto align-items-center justify-content-center">
              <Col lg={6} className="content">
                <Fade bottom duration={1000}>
                  {parse(watchFullProtectors?.heading.html)}

                  <p className="sub font-poppins">
                    {watchFullProtectors?.content?.text}
                  </p>
                </Fade>
              </Col>

              <Col lg={6} className="images">
                <div className="wrapper d-flex g-24">
                  {watchFullProtectors?.images?.map((image, idx) => {
                    return (
                      <Fade bottom duration={1000} delay={100 * (idx + 1)}>
                        <img
                          className={`prot-img`}
                          key={image?.url}
                          src={image?.url}
                          alt="protector"
                        />
                      </Fade>
                    )
                  })}
                </div>
              </Col>
            </Row>
          </section>
        </Fade>

        <ScatterPlot data={scatterPlot} />

        <section className="availability-section">
          <Fade bottom duration={1000}>
            <Row className="container mx-auto align-items-center">
              <Col lg={{ span: 6, offset: 1 }} className="contents">
                <h3>{availabilities?.cardHeading[0]}</h3>
                <p>{availabilities?.cardContent[0]?.text}</p>

                <div className="store-wrapper">
                  {availabilities?.image.map((img, idx) => {
                    return (
                      <a
                        href={availabilities?.cardLinks[idx]}
                        key={availabilities?.cardLinks[idx]}
                      >
                        <img
                          className="store-img"
                          key={idx}
                          src={img?.url}
                          alt="store"
                        />
                      </a>
                    )
                  })}
                </div>
              </Col>

              <Col lg={4} className="img-wrapper">
                <img
                  className="phone-img"
                  src={availabilities?.picture[0]?.url}
                  alt="smart-phone-img"
                />
              </Col>
            </Row>
          </Fade>
        </section>

        <section className="resources-section Layout-container-big">
          <Fade bottom duration={1000}>
            <div>
              <Row className="h-wrapper">
                {parse(resources?.blockContent?.html)}
              </Row>

              <Row className="cover">
                <Col lg={6} className="left-side">
                  <LandingLatestStory
                    isSingleTag={[
                      resources?.blockImageTitle[0],
                      resources?.blocksExcerpt[0],
                    ]}
                    noExcerpt
                    noCredits
                    isBlogLink
                    blockLinkText={resources?.linkName}
                  />
                </Col>

                <Col lg={6} className="right-side d-flex flex-column gap-16">
                  <ResourceCard
                    heading={latestEpisode?.title}
                    tag={resources?.blockImageTitle[1]}
                    tagLink={resources?.blocksExcerpt[1]}
                    secondaryBtnText={resources?.linkName}
                    coverImage={resources?.blockImage[0]?.url}
                    isItemCounter
                    counter={`EPISODE #${latestEpisode?.episodeNumber}`}
                    sourceLink={`/superpod/season1/${latestEpisode?.slug}`}
                    className="episode-card"
                  />

                  <ResourceCard
                    heading={latestEbook?.title}
                    tag={resources?.blockImageTitle[2]}
                    tagLink={resources?.blocksExcerpt[2]}
                    secondaryBtnText={resources?.linkSlug}
                    sourceLink={`/resources/templates/${latestEbook?.slug}`}
                    coverImage={latestEbook?.image?.url}
                    className="ebook-card"
                  />
                </Col>
              </Row>
            </div>
          </Fade>
        </section>

        <section className="cta-2-section">
          <Fade bottom duration={1000}>
            <CTA
              data={[ctaBoxes[1]]}
              bgPattern
              containerClass
              maxDescriptionWidth="475px"
              maxBoxWidth="100%"
              maxRowWidth="1176px"
              lgLeft={5}
              lgRight={7}
              newButton
              newDesign
              isLinkTextWithArrow
            />
          </Fade>
        </section>
      </Frame>
    </div>
  )
}

export default Home2025

export const query = graphql`
  query {
    SuperOps {
      pages(where: { title: "Home-2025" }) {
        title
        heroSection {
          heading {
            html
          }
          content {
            text
          }
          heroImage {
            url
          }
          images {
            url
          }
          primaryButtonLink
          primaryButtonText
          secondaryButtonLink
          secondaryButtonText
        }
        pageImages {
          url
        }
        seo {
          title
          description
          keywords
          image {
            url
          }
        }

        ctaBoxes {
          type
          theme
          customBackgroundColor
          heading {
            html
          }
          description {
            html
          }
          primaryButtonText
          primaryButtonLink
          secondaryButtonText
          secondaryButtonLink
          card {
            cardName
            title
            subtext
            slug
          }
        }

        navigationBlock {
          name
          page {
            heroImage {
              url
            }
            content {
              html
            }
          }
          navigationLinks {
            heading
            subText
            childHeader
            childFooter
            featureNavigationLinks {
              image {
                url
              }
              heading
              subText
              childHeader
              childFooter
              childFooterLink
            }
          }
        }

        newField {
          ... on SuperOps_Card {
            cardHeading: heading
            cardContent: content {
              html
              text
            }
            image {
              url
            }
            picture {
              url
            }
            cardTitle: title
            cardText: text
            cardSubText: subtext
            cardLinks: links
            multiOption {
              option
            }
          }
          ... on SuperOps_Block {
            blockContent {
              html
            }
            blockDescription
            blockImageTitle
            blocksExcerpt
            linkName
            linkSlug
            blockImage {
              url
            }
          }

          ... on SuperOps_Testimonial {
            peopleList {
              position
              name
              title
              picture {
                url
              }
              cardBgColor
              thumbnail {
                url
              }
            }
            testimonialType
            secondaryBtnText
            secondaryBtnLink
            testimonialTitle
            testimonialImage {
              url
            }
          }

          ... on SuperOps_Hero {
            heading {
              html
            }
            content {
              text
            }
            images {
              url
            }
          }
        }
      }
      resources(
        where: { categoryDropdown: One_million }
        first: 1
        orderBy: createdAt_DESC
      ) {
        categoryDropdown
        title
        chapterNumber
        excerpt {
          text
        }
        slug
        image {
          url(transformation: { document: { output: { format: webp } } })
        }
      }

      episodes(orderBy: createdAt_DESC, first: 1) {
        id
        season
        episodeNumber
        superpodPage
        image {
          url(transformation: { document: { output: { format: webp } } })
        }
        coverImage {
          url(transformation: { document: { output: { format: webp } } })
        }
        title
        summary {
          html
        }
        whatYouWillLearn {
          html
        }
        highlights {
          html
        }
        highlights {
          text
        }
        embedded {
          html
        }
        guestName
        guestTitle
        audioFile {
          url
        }
        audioDuration
        type
        superPodGuestTextTheme
        seo {
          title
          description
          keywords
          image {
            url
          }
        }
        slug
      }
    }
  }
`

export const SliderTestimonial = props => {
  const { testimonial, bgImg } = props

  const [sliderClass, setSliderClass] = useState(1)

  const handleMouseClick = idx => {
    setSliderClass(idx)
  }

  let delayCount = 1

  return (
    <section className="slider-testimonial">
      <Container className="position-relative">
        <div className="banner-heading d-flex flex-column w-100">
          <div className="h-1 d-flex justify-content-center align-items-center">
            <Fade bottom duration={1000} delay={300}>
              <img
                className="t-img b-1"
                src={testimonial?.testimonialImage[0]?.url}
                alt={"banner-1"}
              />
            </Fade>

            <Fade bottom duration={1000}>
              <div className="h-1-title text-center font-zodiak fw-800 position-relative">
                <span className="h-1-lg">
                  {testimonial?.testimonialTitle[0]}
                </span>
                <span>{testimonial?.testimonialTitle[1]}</span>
              </div>
            </Fade>

            <Fade bottom duration={1300} delay={300}>
              <img
                className="t-img b-2"
                src={testimonial?.testimonialImage[1]?.url}
                alt={"banner-2"}
              />
            </Fade>
          </div>

          <div className="h-2 d-flex justify-content-space-around align-items-center">
            <Fade bottom duration={1500} delay={300}>
              <img
                className="t-img  b-3"
                src={testimonial?.testimonialImage[2]?.url}
                alt={"banner-3"}
              />
            </Fade>

            <Fade bottom duration={1000}>
              <img
                className="t-b-img"
                src={testimonial?.testimonialImage[4]?.url}
                alt={"rating"}
              />
            </Fade>

            <Fade bottom duration={1700} delay={300}>
              <img
                className="t-img b-4"
                src={testimonial?.testimonialImage[3]?.url}
                alt={"banner-4"}
              />
            </Fade>
          </div>
        </div>

        <div className="d-dsk">
          <Row className="container d-flex">
            {testimonial?.peopleList.map((person, idx) => {
              return (
                <Col
                  className={`wrapper ${sliderClass === idx &&
                    `wrapper-slider`}`}
                  key={person?.name}
                >
                  <Fade
                    bottom
                    delay={delayCount++ * 230}
                    duration="800"
                    distance={"20px"}
                  >
                    <SliderTestimonialCard
                      data={person}
                      handleMouseClick={handleMouseClick}
                      idx={idx}
                      bgImg={sliderClass === idx ? bgImg : ""}
                    />
                  </Fade>
                </Col>
              )
            })}
          </Row>
        </div>

        <Fade bottom duration="800">
          <Container className="d-mob">
            <CarouselComponent status swipeable items={1} autoPlay={false}>
              {testimonial?.peopleList.map((item, idx) => {
                return (
                  <SliderTestimonialCard
                    data={item}
                    bgImg={sliderClass === idx ? bgImg : ""}
                  />
                )
              })}
            </CarouselComponent>
          </Container>
        </Fade>

        <div className="btn-wrapper">
          <Buttons
            theme="primary-new down-to-up-4"
            link={testimonial?.secondaryBtnLink}
            text={testimonial?.secondaryBtnText}
          />
        </div>
      </Container>
    </section>
  )
}

export const BannerHeader = props => {
  const { banners, title, buttonText, buttonLink } = props

  return (
    <div className="banner-heading">
      <div className="h-1">
        <img className="t-img b-1" src={banners[0]?.url} alt={"banner-1"} />

        <div className="h-1-title">{parse(title)}</div>

        <img className="t-img b-2" src={banners[1]?.url} alt={"banner-2"} />
      </div>

      <div className="h-2">
        <img className="t-img  b-3" src={banners[2]?.url} alt={"banner-3"} />

        <div className="d-flex flex-column">
          <img className="t-b-img" src={banners[4]?.url} alt={"rating"} />

          {buttonText && buttonLink && (
            <Buttons
              theme="primary-new down-to-up-4"
              link={buttonLink}
              text={buttonText}
            />
          )}
        </div>

        <img className="t-img b-4" src={banners[3]?.url} alt={"banner-4"} />
      </div>
    </div>
  )
}

export const SliderTestimonialCard = props => {
  const { data, handleMouseClick, idx, showQuote, bgImg, noImg } = props

  return (
    <>
      <div className="d-dsk">
        <div
          className={`person-card d-flex ${noImg && `justify-content-center`}`}
          style={{ background: data?.cardBgColor }}
          onClick={() => {
            if (typeof handleMouseClick === "function") handleMouseClick(idx)
          }}
        >
          {!noImg && (
            <div className="person-images">
              <img
                src={bgImg ?? ""}
                alt={bgImg ?? ""}
                className={`p-bg-img ${idx} ${bgImg && "bg-img-animation"}`}
              />
              <img
                className="w-100 p-img"
                src={data?.picture?.url}
                alt={`${data?.name} img`}
              />
              <img
                className="w-100 p-comp"
                src={data?.thumbnail?.url}
                alt={""}
              />
            </div>
          )}

          <div className="person-info">
            <div>
              {showQuote && (
                <SVGIcon name="curveQuote" className="quote-icon mb24" />
              )}
              <p className="person-words">{data?.title}</p>
            </div>
            <div className="person-details">
              <p className="person-name">{data?.name}</p>
              <p className="person-position">{data?.position}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="d-mob">
        <div
          className={`slider-testimonial-mob-container`}
          style={{ background: data?.cardBgColor }}
        >
          <div className="top">
            {showQuote && (
              <SVGIcon name="curveQuote" className="quote-icon mb24" />
            )}
            <p className="desc">{data?.title}</p>
          </div>

          <div className="bottom">
            {!noImg && (
              <div className="p-img-wrapper">
                <img
                  className="w-100 p-img"
                  src={data?.picture?.url}
                  alt={`${data?.name} img`}
                />
                <img
                  className="w-100 p-comp"
                  src={data?.thumbnail?.url}
                  alt={data?.thumbnail?.url}
                />
              </div>
            )}
            <div className={`p-wrapper ${noImg && "px-24"}`}>
              <p className="p-name">{data?.name}</p>
              <p className="p-position">{data?.position}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const ResourceCard = props => {
  const {
    heading,
    tag,
    tagLink,
    secondaryBtnText,
    coverImage,
    isItemCounter,
    counter,
    sourceLink,
    className,
  } = props

  return (
    <Link
      to={sourceLink}
      className={`resource ${className} p-0 d-flex align-items-center position-relative flex-1`}
    >
      <div className="cover-img-wrapper overflow-hidden w-100 h-100">
        <img className="cover-img" src={coverImage} alt="podcast-cover-image" />
      </div>

      <div className="contents-wrapper h-100 position-relative">
        <div className="top">
          <Link className="tag font-poppins" to={tagLink}>
            {tag}
          </Link>

          <p className="heading truncate-2l font-zodiak fw-800">{heading}</p>
        </div>

        <div className="bottom-wrapper position-absolute w-100">
          <div
            className={`bottom d-flex position-absolute w-100 ${
              isItemCounter
                ? "justify-content-between"
                : "justify-content-start"
            } align-items-center`}
          >
            <Col
              className="sec-btn link font-poppins d-flex align-items-center"
              lg={8}
            >
              {secondaryBtnText}
              <SVGIcon name="hypertext-arrow-right" className="arrow-right" />
            </Col>
            {isItemCounter && (
              <Col
                className="counter-id text-right font-poppins position-relative"
                lg={4}
              >
                {counter}
              </Col>
            )}
          </div>
        </div>
      </div>
    </Link>
  )
}

export const PromotionCards = props => {
  const {
    tittleTags,
    subTittleTags,
    descriptions,
    creditTags,
    subCreditTags,
    bgColors,
    headingHtml,
  } = props

  let delayCount = 1

  return (
    <section className="promotions Layout-container-big">
      <Fade bottom distance="30px" duration={1300}>
        <Row className="rich-text-heading text-center">
          {parse(headingHtml)}
        </Row>
      </Fade>
      <Row className="card-container d-dsk d-flex">
        {descriptions &&
          descriptions?.map((description, idx) => {
            return (
              <Col lg={6} xl={3}>
                <Fade
                  bottom
                  delay={delayCount++ * 130}
                  duration="800"
                  distance={"20px"}
                >
                  <CardX
                    tittleTags={tittleTags}
                    subTittleTags={subTittleTags}
                    description={description}
                    creditTags={creditTags}
                    subCreditTags={subCreditTags}
                    bgColors={bgColors}
                    idx={idx}
                  />
                </Fade>
              </Col>
            )
          })}
      </Row>

      <Fade bottom duration={1000}>
        <Row className="card-container d-mob">
          <CarouselComponent
            status
            swipeable
            items={1.9}
            autoPlay={false}
            responsive={responsive}
          >
            {descriptions &&
              descriptions?.map((description, idx) => {
                return (
                  <CardX
                    tittleTags={tittleTags}
                    subTittleTags={subTittleTags}
                    description={description}
                    creditTags={creditTags}
                    subCreditTags={subCreditTags}
                    bgColors={bgColors}
                    idx={idx}
                  />
                )
              })}
          </CarouselComponent>
        </Row>
      </Fade>
    </section>
  )
}

export const CardX = props => {
  const {
    tittleTags,
    subTittleTags,
    description,
    creditTags,
    subCreditTags,
    bgColors,
    idx,
  } = props

  return (
    <Col
      lg={3}
      className={`promo-card d-flex flex-column justify-content-space-around align-items-stretch h-100`}
      style={{ background: `${bgColors && bgColors[idx]}` }}
    >
      <div className="top-section">
        {tittleTags[idx] && <p className="title-tag">{tittleTags[idx]}</p>}
        {subTittleTags[idx] && (
          <p className="sub-title-tag">{subTittleTags[idx]}</p>
        )}
      </div>

      <div className="mid-section">
        <p className="description">{description}</p>
      </div>

      <div className="bottom-section">
        {creditTags[idx] && <p className="credit-tag">{creditTags[idx]}</p>}
        {subCreditTags[idx] && (
          <p className="sub-credit-tag">{subCreditTags[idx]}</p>
        )}
      </div>
    </Col>
  )
}

export const NestedVerticalTabs = props => {
  const { navigationLinks, page } = props.data

  const heading = page[0]?.content.html
  const headingIcon = page[0]?.heroImage.url

  const [activeIndex, setActiveIndex] = useState(0)

  const handleTabChange = i => {
    setActiveIndex(i)
  }

  return (
    <section
      className="vertical-tabs"
      style={{
        background: `linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) -0.53%,
      ${lightColors[activeIndex]} 50.63%,
      rgba(255, 255, 255, 0) 100.38%
    )`,
      }}
    >
      <div className="vertical-tabs-container Layout-container-big">
        <Fade bottom duration={1000}>
          <div className="heading-wrapper position-relative">
            {parse(heading)}
            <img
              src={headingIcon}
              alt={headingIcon}
              className="twinkle-img-wrapper position-absolute"
            />
          </div>
        </Fade>

        <div className="tabs-container d-dsk">
          <div className="d-flex">
            <Fade bottom duration={1000}>
              <div
                className={`button-wrapper d-flex justify-content-between br10`}
              >
                {navigationLinks?.map((item, i) => {
                  return (
                    <button
                      key={item.heading}
                      className={`resource-button d-flex border-0 br10 z-1 alt ${i ===
                        activeIndex && "active"}`}
                      onClick={() => handleTabChange(i)}
                      role="button"
                      tabIndex={0}
                      css={css`
                        background: linear-gradient(
                          90deg,
                          ${darkColors[i]} -60%,
                          rgba(255, 255, 255, 0) 80%
                        );

                        &.active {
                          background: linear-gradient(
                            90deg,
                            ${darkColors[i]} 0%,
                            ${lightColors[i]} 103.13%
                          );
                        }

                        &::before {
                          content: "";
                          width: 0;
                          height: 100%;
                          position: absolute;
                          left: 0;
                          bottom: 0;
                          background: linear-gradient(
                            90deg,
                            ${darkColors[i]} 0%,
                            ${lightColors[i]} 103.13%
                          );
                          transition: 0.4s ease-in-out;
                          z-index: -1;
                        }

                        &::after {
                          background-repeat: no-repeat;
                          background-position: 50%;
                          background-size: contain;
                          width: 10px;
                          height: 10px;
                          display: inline-block;
                          transform: translate(5px, 0px);
                          transition: 0.4s ease-in-out;
                          vertical-align: top;
                          filter: invert(1);
                        }

                        &:hover {
                          background-color: transparent;

                          &::after {
                            transform: translate(8px, 0px);
                            filter: invert(0);
                          }

                          &::before {
                            width: 100%;
                          }
                        }
                      `}
                    >
                      <div className="button-name d-flex align-items-center justify-content-between fw-bold">
                        {item?.heading.toUpperCase()}
                        <SVGIcon
                          name="home/rightArrBlack"
                          className="right-arrow-black"
                        />
                      </div>
                    </button>
                  )
                })}
              </div>
            </Fade>
          </div>
        </div>

        <div className="d-dsk">
          {navigationLinks.map((item, i) => {
            return (
              <div className={`${i === activeIndex ? "fade-reveal" : "hide"}`}>
                <ContentComponent data={item} activeIndex={activeIndex} />
              </div>
            )
          })}
        </div>

        <div className="d-mob">
          {navigationLinks.map((item, i) => {
            return (
              <Fade delay={i * 50} bottom distance="30px">
                <ContentComponent data={item} activeIndex={i} />
              </Fade>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export const ContentComponent = props => {
  const { data, activeIndex, bgImgGradient } = props

  const [nestedIndex, setNestedIndex] = useState(0)

  const handleNestedTabChange = i => {
    if (data?.featureNavigationLinks.length > 0) setNestedIndex(i)
  }

  useEffect(() => {
    if (data?.featureNavigationLinks.length > 0) handleNestedTabChange(0)
  }, [activeIndex])

  return (
    <div className="mt50 mb50">
      <Row className="content-container">
        <Col sm={12} className="d-mob main-tag">
          <p
            className="text-deep-purple"
            style={{
              background: `linear-gradient(
                          90deg,
                          ${darkColors[activeIndex]} -60%,
                          rgba(255, 255, 255, 0) 80%
                        )`,
            }}
          >
            {data.heading}
          </p>
        </Col>

        <Col lg={5} className="left-col">
          <h4 className="heading">{data?.subText}</h4>
          <p className="sub-heading">{data?.childHeader}</p>

          <div className="nested-container">
            <div className="nested-tabs-wrapper">
              {data?.featureNavigationLinks?.map((item, i) => {
                return (
                  <button
                    className={`nested-tab-btn ${i === nestedIndex &&
                      "n-active"}`}
                    onClick={() => {
                      handleNestedTabChange(i)
                    }}
                  >
                    {item?.heading}
                  </button>
                )
              })}
            </div>

            {(data?.featureNavigationLinks).map((item, i) => {
              return (
                <div className={`${i === nestedIndex ? "reveal" : "hide"}`}>
                  <NestedContents data={item} />
                </div>
              )
            })}
          </div>
        </Col>

        {data?.featureNavigationLinks.map((item, i) => {
          return (
            <Col
              lg={7}
              className={`right-col position-relative ${
                i === nestedIndex ? "reveal" : "hide"
              }`}
            >
              <img
                src={item?.image?.url}
                alt=""
                className={`right-side-img w-100 position-relative`}
              />
              <img
                className="twinkle-icon position-absolute reveal-1"
                src={
                  "https://us-west-2.graphassets.com/AsRMKMrtKTFW6TGbr4KgUz/eYAV5mgSJiNwRcfjzw2E"
                }
                alt="twinkle-icon"
              />

              <div
                className="background-gradient position-absolute"
                css={css`
                  background: linear-gradient(
                    0deg,
                    rgba(255, 170, 171, 1) 38.53%,
                    rgba(138, 89, 177, 1) 67.93%
                  );
                `}
              />
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export const NestedContents = props => {
  const { data } = props

  return (
    <div className="nested-contents reveal-1">
      <ul className="list-wrapper list-unstyled">
        <li className="list-item position-relative">
          <h6 className="n-h fw-800 font-zodiak reveal-1">{data?.subText}</h6>
          <p className="n-d font-poppins reveal-2">{data?.childHeader}</p>
          <div className="btn-wrapper reveal-3">
            <Buttons
              theme="primary-new white-new n-l"
              text={data?.childFooter}
              link={data?.childFooterLink}
            />
          </div>
        </li>
      </ul>
    </div>
  )
}

export const ScatterPlot = props => {
  const { data } = props

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    const icons = gsap.utils.toArray(".i-w")

    icons.forEach(card => {
      gsap.to(card, {
        scrollTrigger: {
          // markers: true,
          start: "top 500px",
          end: "bottom 400px",
          scrub: 1.2,
          trigger: card,
          toggleActions: "start end reverse restart",
          invalidateOnRefresh: true,
        },
        x: 0,
        y: 0,
      })
    })
  }, [])

  return (
    <section className="scatter-plot position-relative d-flex justify-content-center align-items-center">
      <div className="plot-container position-absolute start-50">
        <div className="position-relative">
          <div className="main-container">
            <div className="tire-1">
              <div className="i-0-wrapper parent-wrapper">
                <div className="i-0-child child" />

                <div class="i-0-image-wrapper i-w">
                  <img
                    src={data?.image[0]?.url}
                    alt={data?.image[0]?.url}
                    className="actual-image w-100 i-0"
                  />
                </div>
              </div>

              <div className="i-1-wrapper parent-wrapper">
                <div className="i-1-child child" />

                <div class="i-1-image-wrapper  i-w">
                  <img
                    src={data?.image[1]?.url}
                    alt={data?.image[1]?.url}
                    className="actual-image w-100 i-1"
                  />
                </div>
              </div>

              <div className="i-2-wrapper parent-wrapper">
                <div className="i-2-child child" />

                <div class="i-2-image-wrapper i-w">
                  <img
                    src={data?.image[2]?.url}
                    alt={data?.image[2]?.url}
                    className="actual-image w-100 i-2"
                  />
                </div>
              </div>

              <div className="i-3-wrapper parent-wrapper">
                <div className="i-3-child child" />

                <div class="i-3-image-wrapper i-w">
                  <img
                    src={data?.image[3]?.url}
                    alt={data?.image[3]?.url}
                    className="actual-image w-100 i-3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="position-relative">
          <div className="main-container">
            <div className="tire-2">
              <div className="i-9-wrapper parent-wrapper">
                <div className="i-9-child child" />

                <div class="i-9-image-wrapper i-w">
                  <img
                    src={data?.image[9]?.url}
                    alt={data?.image[9]?.url}
                    className="actual-image w-100 i-9"
                  />
                </div>
              </div>

              <div className="i-4-wrapper parent-wrapper">
                <div className="i-4-child child" />

                <div class="i-4-image-wrapper i-w">
                  <img
                    src={data?.image[4]?.url}
                    alt={data?.image[4]?.url}
                    className="actual-image w-100 i-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="position-relative">
          <div className="main-container">
            <div className="tire-3">
              <div className="i-5-wrapper parent-wrapper">
                <div className="i-5-child child" />

                <div class="i-5-image-wrapper i-w">
                  <img
                    src={data?.image[5]?.url}
                    alt={data?.image[5]?.url}
                    className="actual-image w-100 i-5"
                  />
                </div>
              </div>

              <div className="i-6-wrapper parent-wrapper">
                <div className="i-6-child child" />

                <div class="i-6-image-wrapper i-w">
                  <img
                    src={data?.image[6]?.url}
                    alt={data?.image[6]?.url}
                    className="actual-image w-100 i-6"
                  />
                </div>
              </div>

              <div className="i-7-wrapper parent-wrapper">
                <div className="i-7-child child" />

                <div class="i-7-image-wrapper i-w">
                  <img
                    src={data?.image[7]?.url}
                    alt={data?.image[7]?.url}
                    className="actual-image w-100 i-7"
                  />
                </div>
              </div>

              <div className="i-8-wrapper parent-wrapper">
                <div className="i-8-child child" />

                <div class="i-8-image-wrapper i-w">
                  <img
                    src={data?.image[8]?.url}
                    alt={data?.image[8]?.url}
                    className="actual-image w-100 i-8"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="contents-wrapper d-flex flex-column align-items-center">
          {parse(data?.cardContent[0]?.html)}

          <p className="sub-heading font-poppins text-center">
            {data?.cardText}
          </p>

          <Buttons
            theme="primary-new white-new down-to-up-4"
            text={data?.cardSubText}
            link={data?.cardLinks}
          />
        </div>
      </div>
    </section>
  )
}
